import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

/** The Inventory snapshots page's icon: a storage box with an upload arrow (stroke icon). */
export const InventorySnapshotIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
    >
      <rect
        x={3}
        y={3}
        width={18}
        height={5}
        rx={1}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M4.5 8v12a1 1 0 0 0 1 1h6.5M19.5 8v4"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M10 12h4"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M18 22v-8M14.5 17.5 18 14l3.5 3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
